import { HttpContextToken } from '@angular/common/http';

// Requests die deze token op true zetten worden door responseInterceptor doorgelaten zonder
// ResponseStateService.apply() aan te roepen. Nodig voor calls die zelf (indirect) DomainProfileService
// nodig hebben terwijl die nog geconstrueerd wordt (zie domain-default-profile-api.service.ts) —
// zonder deze uitzondering ontstaat NG0200 (circulaire DI: interceptor -> ResponseStateService ->
// DomainProfileService, terwijl DomainProfileService's eigen constructor nog op de call-stack staat).
export const SKIP_RESPONSE_STATE = new HttpContextToken<boolean>(() => false);
